import { Card } from '@material-ui/core';
import styled from 'styled-components';

export const ResultCard = styled(Card)`
  padding: 18px 27px 18px 27px;
  width: 48%;
  min-width: 300px;
  margin-bottom: 20px;
`;

export const TitleContainer = styled.div`
  width: 100%;
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 32px;

  text-transform: uppercase;

  color: #000000;
`;
